// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3XKUB","errorLogs":"styles_errorLogs__1sGjz"};